import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { displayAlert, openModal } from 'store/v1/ui/ui.actions';
import { createContact } from 'store/v1/contacts/contacts.actions';
import { CONTACTS_ACTIONS } from 'store/v1/contacts/contacts.constants';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  ListCellGroup,
  ListCell,
  PressStud,
  Grid,
  GridCell
} from 'v1/components/shared';

import { generateResourceFromApplicant } from 'v1/helpers/byModel/applicantHelper';
import useEvent from 'v1/helpers/hooks/useEvent';
import { useCalloutFieldMappings } from 'v5/features/callouts/useCalloutFieldMappings';
import { rd } from '@passionware/monads';
import { useBrowsingCustomFieldWorkspaceId } from 'v5/core/custom-fields/useResolveCustomFieldValue';
import { myServices } from 'v5/services/services.connected.app';

import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';

const CalloutReviewActionsPopover = ({ callout, selectedApplicant = {} }) => {
  const dispatch = useDispatch();

  const [actionSelected, setActionSelected] = useState('OPTIONS_VIEW');
  const { resource_type_id: resourceTypeId } = callout;

  useEvent(CONTACTS_ACTIONS.CREATE_CONTACT, {
    onSuccess: () => {
      dispatch(displayAlert('success', 'Resource created'));
    }
  });

  const { i18n } = useTranslation();

  const {
    fieldMapper: calloutFieldMapper,
    overlayDefinitionIds,
    overlayLensReady
  } = useCalloutFieldMappings(
    resourceTypeId,
    callout.enterprise_workspace_id,
    i18n,
    myServices
  );
  const modalAppScope = myServices.appScopeService.useSlugAppScope();
  const customFieldWorkspaceIdRd =
    useBrowsingCustomFieldWorkspaceId(myServices);
  const isBrowsingScopeReady = rd.isSuccess(customFieldWorkspaceIdRd);
  const isCreateReady = isBrowsingScopeReady && overlayLensReady;

  function generateResource() {
    const customFieldWorkspaceId = rd.tryGet(customFieldWorkspaceIdRd);
    if (
      customFieldWorkspaceId === undefined ||
      !overlayLensReady ||
      isEmpty(selectedApplicant)
    ) {
      return;
    }

    return generateResourceFromApplicant(
      selectedApplicant,
      callout,
      calloutFieldMapper,
      customFieldWorkspaceId,
      { overlayDefinitionIds }
    );
  }

  function onAddasResource() {
    const resource = generateResource();
    if (resource) {
      return dispatch(createContact(resource));
    }
  }
  return (
    <Popover>
      <PopoverTrigger disabled={isEmpty(selectedApplicant) || !isCreateReady}>
        <PressStud
          icon="addWhite"
          label="Add"
          appearance="primary"
          isDisabled={isEmpty(selectedApplicant) || !isCreateReady}
          action={() => setActionSelected('OPTIONS')}
          size="S"
        />
      </PopoverTrigger>
      <PopoverContent className="ApplicantReviewActions-popover inset-S">
        {({ closePopover }) => {
          switch (actionSelected) {
            case 'OPTIONS_VIEW':
            default:
              return (
                <>
                  <h3>Add as new resource</h3>
                  <div className="text-13-600-eggplant stack-S">
                    Create a new resource with this applicant
                  </div>
                  <ListCellGroup className="ApplicantReviewActions-actionButtons">
                    <ListCell
                      onClick={() => {
                        closePopover();
                        onAddasResource();
                      }}
                    >
                      <Grid gutters="S">
                        <GridCell width="auto">
                          <img
                            src="/images/icon_sidebar_contacts_individual_colour.svg"
                            width="15px"
                            alt=""
                          />
                        </GridCell>
                        <GridCell>
                          <h5 className="text-13-700">Quick Create</h5>
                          <div className="text-13-600-eggplant">
                            Automatically create a new resource with applicant
                            details
                          </div>
                        </GridCell>
                      </Grid>
                    </ListCell>
                    <ListCell
                      onClick={() => {
                        closePopover();
                        const resource = generateResource();
                        if (resource) {
                          dispatch(
                            openModal(
                              'ResourceCreateModal',
                              resource,
                              modalAppScope
                            )
                          );
                        }
                      }}
                    >
                      <Grid gutters="S">
                        <GridCell width="auto">
                          <img
                            src="/images/icon_sidebar_contacts_individual_colour.svg"
                            width="15px"
                            alt=""
                          />
                        </GridCell>
                        <GridCell>
                          <h5 className="text-13-700">
                            Edit & Create New Resource
                          </h5>
                          <div className="text-13-600-eggplant">
                            Open up a new resource panel to edit the new
                            resource before saving
                          </div>
                        </GridCell>
                      </Grid>
                    </ListCell>
                  </ListCellGroup>
                </>
              );
          }
        }}
      </PopoverContent>
    </Popover>
  );
};

export default CalloutReviewActionsPopover;
